import "./glossary/glossary.scss";

window.letterNav = function () {
  return {
    open: true,
    stuck: false,
    init() {
      //set height of toggle button
      this.setScrollOffset(this.$refs.toggleButton);

      //close menu when a letter link is clicked
      const letterLinks = document.querySelectorAll(".letterNav__letterLink");
      letterLinks.forEach((el) => {
        el.addEventListener("click", (e) => {
          e.preventDefault();
          this.open = false;
          this.stuck = true;

          this.$nextTick(() => {
            this.setScrollOffset(this.$refs.nav);
            location.hash = e.target.hash;
          });
        });
      });

      //toggle stuck state via intersection observer
      const navObserver = new IntersectionObserver(
        ([e]) => {
          if (e.intersectionRatio === 0) {
            this.open = false;
            navObserver.unobserve(this.$refs.nav);
            this.stuck = true;
            this.$root.classList.add("u-sticky");
            buttonObserver.observe(this.$refs.toggleButton);
          }
        },
        { threshold: [0] }
      );
      navObserver.observe(this.$refs.nav);

      const buttonObserver = new IntersectionObserver(
        ([e]) => {
          if (e.intersectionRatio === 1) {
            this.open = true;
            buttonObserver.unobserve(this.$refs.toggleButton);
            this.stuck = false;
            this.$root.classList.remove("u-sticky");
            navObserver.observe(this.$refs.nav);
          }
        },
        { threshold: [1] }
      );
    },
    setScrollOffset(el) {
      const bBox = el.getBoundingClientRect();
      document.documentElement.style.setProperty(
        "--scrollPaddingTop",
        bBox.height + 40 + "px"
      );
    },
  };
};

//TOC with Intersection Observer
//thx https://benfrain.com/building-a-table-of-contents-with-active-indicator-using-javascript-intersection-observers/
const content = document.querySelector(".glossary__terms");
const hTags = Array.from(content.querySelectorAll(":scope > h2"));
const allSectionLinks = document.querySelectorAll(".letterNav__letterLink");
const activeClass = "letterNav__letterLink--active";

// Each Intersection Observer runs setCurrent
const observeHTags = new IntersectionObserver(setCurrent, {
  root: null,
  rootMargin: "-10% 0px -40% 0px",
  threshold: [1],
});

hTags.forEach((letter) => {
  observeHTags.observe(letter);
});

//Determine if the intersecting element is above or below halfway down the screen
function didThisIntersectionHappenAtTop(i) {
  return (
    i.rootBounds.bottom - i.boundingClientRect.bottom > i.rootBounds.bottom / 2
  );
}

function getPriorHeading(i) {
  let priorEle = (ele) => ele === i.target;
  return hTags.findIndex(priorEle);
}

const isInViewport = (element) => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >=
      (window.innerHeight * 0.1 ||
        document.documentElement.clientHeight * 0.1) &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight * 0.6 ||
        document.documentElement.clientHeight * 0.6) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

function setActive(id) {
  allSectionLinks.forEach((link) => link.classList.remove(activeClass));
  if (id) {
    history.replaceState(null, null, `#${id}`);
    document.querySelector(`a[href="#${id}"]`).classList.add(activeClass);
  }
}

// Function that runs when the Intersection Observer fires
function setCurrent(e) {
  //console.log(e);
  e.map((i) => {
    //console.log(i.target, i.isIntersecting);
    let top = didThisIntersectionHappenAtTop(i);
    // Page just loaded ... probably and a heading is in view
    if (i.time < 1000 && i.isIntersecting) {
      //console.log(1);
      setActive(i.target.id);
    } else if (i.time < 1000) {
      //console.log(2);
      // In this case page just loaded and no heading in view
      return;
    } else if (!top && i.isIntersecting === false) {
      //console.log(3);
      // This section deals with scrolling up the page.
      //First check if another element is still in view, if so use that
      const topMostVisibleH = hTags.find(isInViewport);

      if (topMostVisibleH) {
        //console.log(3.1);
        setActive(topMostVisibleH.id);
      } else {
        //console.log(3.2);
        //Otherwise, get the previous element and set that as current
        // First we find if the heading being scrolled off the bottom is the first H tag in source order.
        let indexOfThisHeading = getPriorHeading(i);
        if (indexOfThisHeading === 0) {
          //console.log("3.2.1");
          // The first H tag just scrolled off the bottom of the viewport and it is the first H tag in source order
          setActive(false);
        } else {
          //console.log("3.2.2");
          // An H tag scrolled off the bottom. It isn't the first so make the previous heading current
          setActive(hTags[indexOfThisHeading - 1].id);
        }
      }
    } else if (i.isIntersecting) {
      //console.log(4);
      // For all other instances we want to make this one current and the others not current
      setActive(i.target.id);
    }
  });
}
